export default __webpack_public_path__ + "static/media/Heroz.019feb95.jpg";